import CSS from "./static/css/header.module.css";
import { useEffect, useState } from "react";
import MainTitle from "../../Component/Elements/MainTitle/MainTitle";
import UserFunctionBtn from "./components/UserFunctionBtn/UserFunctionBtn";
import { mobileBackgroundColorType } from "../../Common/interface/style.interface";
import useAlarmNewCountREST from "./hooks/useAlarmNewCountREST.hook";
import AlertIconBtn from "./components/AlertIconBtn/AlertIconBtn";
import { useLocation } from "react-router-dom";
import { getBackPath } from "./static/ts/Header.tools";
import HistoryBackBtn from "../../Component/Elements/HistoryBackBtn/HistoryBackBtn";
import Text from "../../Component/Elements/Text/Text";
import HomeLinkLogo from "../../Component/Elements/HomeLinkLogo/HomeLinkLogo";

const Header = (
    {
        headerLeftNode,
        headerRightNode,
        mobileHeaderTitle,
        headerBackgroundColorPreset,
    }:{
        headerLeftNode: React.ReactNode;
        headerRightNode: React.ReactNode;
        mobileHeaderTitle: string;
        headerBackgroundColorPreset: mobileBackgroundColorType;
    }
) => {
    const {
        alarmNewCountData,
        alarmNewCountIsLoading,
        alarmNewCountError,
        alarmNewCountRefetch,
    } = useAlarmNewCountREST();

    const classNameSetter = () => {
        const RTN: string[] = [CSS.l_header_main];

        if(headerBackgroundColorPreset){
            RTN.push(CSS.background_color_preset);
            RTN.push(CSS[headerBackgroundColorPreset]);
        }

        return RTN;
    }

    const [mainClassName, setMainClassName] = useState<string>(classNameSetter().join(" "));

    useEffect(() => {
        setMainClassName(classNameSetter().join(" "));
    }, [headerBackgroundColorPreset])

    // 뒤로가기버튼출현은 외부 조건에따라 처리하게 하자. 너무 자동으로하는것은 좋지못한듯
    const location = useLocation();

    return (
        <header className={mainClassName}>
            <div className={CSS.l_header_left}>
                {
                    headerLeftNode
                    ?   headerLeftNode
                    :   getBackPath(location.pathname)
                        &&   <HistoryBackBtn />
                }

                {
                    !headerLeftNode
                    && !getBackPath(location.pathname)
                    &&  <div className={CSS.MobileBrand}>
                            <HomeLinkLogo />
                        </div>
                }

            </div>

            <MainTitle
                title={mobileHeaderTitle}
                isHeaderTitle={true}
            />

            <div className={CSS.l_header_right}>
                {
                    process.env.REACT_APP_MODE !== "PRODUCT"
                    &&  <Text
                            preset={"AccoutPageTitle"}
                        >
                            {process.env.REACT_APP_MODE} MODE
                        </Text>
                }

                {
                    headerRightNode
                    ||  <>
                            <AlertIconBtn
                                is_active={alarmNewCountData > 0}
                            />
                            <UserFunctionBtn />
                        </>
                }
            </div>
        </header>
    )
}

export default Header;
